export const PUBLIC_PROFILE_FIELDS = [
  'id',
  'username',
  'full_name',
  'bio',
  'avatar_url',
  'bg_type',
  'bg_color',
  'bg_image',
  'bg_video',
  'bg_texture',
  'texture_opacity',
  'bg_blur',
  'bg_pos_x',
  'bg_pos_y',
  'font_family',
  'title_font_family',
  'bio_font_family',
  'link_font_family',
  'font_weight',
  'title_font_weight',
  'title_font_size',
  'bio_font_weight',
  'bio_font_size',
  'link_font_weight',
  'link_font_size',
  'font_spacing',
  'font_type',
  'custom_fonts',
  'theme',
  'title_color',
  'bio_color',
  'link_text_color',
  'accent_color',
  'seo_title',
  'seo_description',
  'button_style',
  'button_color',
  'button_shape',
  'button_shadow',
  'button_border',
  'button_radius',
  'button_border_width',
  'shadow_color',
  'shadow_direction',
  'hover_effect',
  'hover_fill_color',
  'hover_fill_text_color',
  'hover_glow_color',
  'hover_glow_size',
  'hover_tilt_degree',
  'hover_lift_height',
  'hover_pop_scale',
  'hover_shake_intensity',
  'liquid_color_scheme',
  'liquid_custom_color',
  'liquid_intensity',
  'card_style',
  'card_bg',
  'card_bg_type',
  'card_bg_image',
  'card_bg_video',
  'card_radius',
  'card_shadow',
  'card_width',
  'card_opacity',
  'card_blur',
  'card_padding',
  'is_canvas_mode',
  'x_pos',
  'y_pos',
  'layout_sections',
  'tabs',
  'tab_style',
  'about_content',
  'show_avatar',
  'show_name',
  'show_bio',
  'show_username',
  'is_verified',
  'show_verified',
  'show_affiliate_disclaimer',
  'show_branding_footer',
  'branding_footer_opacity',
  'show_notify_btn',
  'contact_email',
  'avatar_size',
  'avatar_align',
  'avatar_shape',
  'avatar_ring',
  'header_type',
  'banner_image',
  'social_icon_style',
  'technical_tags',
  'social_links',
  'shop_products',
  'shop_layout',
  'tip_jar',
  'shop_title',
  'shop_description',
  'shop_cta',
  'ga_measurement_id',
  'meta_pixel_id',
  'animation_type',
  'animation_color',
  'animation_intensity',
  'animation_speed',
  'animation_density',
  'animation_custom_data',
  'created_at',
  'updated_at',
  'leap_link_enabled',
  'leap_link_url',
  'is_searchable',
  'is_in_directory',
  'banner_media_type',
  'banner_video',
  'header_fade_height',
  'header_fade_color',
  'header_overlay_opacity',
  'c2pa_did',
  'is_locked',
  'bg_gradient_from',
  'bg_gradient_to',
  'title_logo',
  'utility_button_color',
  'utility_button_bg_color',
];

export const PUBLIC_PROFILE_SELECT = PUBLIC_PROFILE_FIELDS.join(',');
